import parse from 'html-react-parser';
import PhotoSwiper from './PhotoSwiper';
import axios from 'axios';
import { useState, useEffect } from 'react';
import { APIURL } from '..';
import { useContext } from 'react';
import { AppContext } from '../App';
import Tabs from "./UI/Tabs";
import { useLenis } from '@studio-freight/react-lenis';

const ZeptejSe = () => {
    const [data, setData] = useState();
    const {language, translation,tab, setTab,zeptejse_title, zeptejse_perex, obchod_text, diplomacie_text, turismus_text, obchod_link,obchod_link_ing,diplomacie_link, diplomacie_link_ing, turismus_link, turismus_link_ing, pravo_text, pravo_link, business_text, business_link, business_link_mgr, diplomatic_text, diplomatic_link,diplomatic_link_mgr } = useContext(AppContext);

    const getStudents = async () => {
        await axios.post(APIURL+'/collection/items', {type: 'students', orderAsc: 'ASC', limit: 100, page: 1,language: translation}).then(response =>{
            setData(response.data.body.items.sort(() => Math.random() - 0.5));
        })
    }
    const filter = name => data.filter(i=>(i.program.includes(name)&&(language==='cz'?(i.degree?.toLowerCase()===(tab==='bc'?'bc':'ing')||!i.degree):true)));
    
    useEffect(()=>{
        getStudents();
    }, [tab,translation])

    
    if (data) return (
        <section id='zeptejse' className="py-top px-2vw">
            {language==='cz'&&<Tabs onChange={(v)=>setTab(v?'mgr':'bc')} />}
            <h2 className='text-center pt-4 tablet:text-left'>{zeptejse_title}</h2>
            <p className='text-center tablet:text-left py-4'>{zeptejse_perex}</p>
            {language==='cz'?<>
            <ZeptejseSekce heading='Mezinárodní obchod' text={obchod_text} url={tab==='bc'?obchod_link:obchod_link_ing} data={filter('obchod')} />
            <ZeptejseSekce heading='Mezinárodní studia a diplomacie' text={diplomacie_text} url={tab==='bc'?diplomacie_link:diplomacie_link_ing} data={filter('diplomacie')} reverse />
            <ZeptejseSekce heading='Turismus a hospitality management' text={turismus_text} url={tab==='bc'?turismus_link:turismus_link_ing} data={filter('hospitality')} />
            <ZeptejseSekce heading='Podnikání a právo' text={pravo_text} url={pravo_link} data={filter('právo')} reverse />
                </>:<>
            <ZeptejseSekce heading='International Business' text={business_text} url_bc={business_link} url_mgr={business_link_mgr} data={data.filter(i=>i.program.includes('business'))} />
            <ZeptejseSekce heading='International and Diplomatic Studies' text={diplomatic_text} url_bc={diplomatic_link} url_mgr={diplomatic_link_mgr} data={data.filter(i=>i.program.includes('diplomatic'))} reverse />
            </>}
        </section>
    )
}

const ZeptejseSekce = ({heading, text, url, url_bc, url_mgr, data, reverse}) => {
    const {language, readmore, bachelor, master} = useContext(AppContext);
    if (data.length>0) return (
    <div className={"py-4 flex tablet:flex-col justify-between items-center "+(reverse?'flex-row-reverse':'')}>
        <div className={"w-2/5 tablet:w-full z-[2] "+(reverse?'pl-4 tablet:pl-0':'')}>
            <h3>{heading}</h3>
            {text&&<div className='parsedDiv'>{parse(text)}</div>}
            {url&&<a href={url} className='button' target="_blank">{readmore}</a>}
            <div className='flex pt-4 gap-4'>
            {url_bc&&<a href={url_bc} className='button' target="_blank">{bachelor||"Bachelor"}</a>}
            {url_mgr&&<a href={url_mgr} className='button' target="_blank">{master||"Master"}</a>}
            </div>
        </div>
        <div className="w-3/5 tablet:w-full py-4">
            <PhotoSwiper data={data} />
        </div>
    </div>
)}

export default ZeptejSe